import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import { ToastContainer } from "react-toastify";
import Homepage from './Homepage.js';
import Solutions from './Solutions.js';
import UseCase from './UseCase.js';
import AboutUs from './AboutUs.js';
import Contact from './Contact.js';
import Survey from './Survey.js';

function App() {
  return (
    <>
    <Router>
        <ScrollToTop /> {/* Automatically handles scrolling */}
        <Routes>
            <Route path="/" element={<Homepage />} /> {/* Home is the default page */}
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/usecase" element={<UseCase />} />
            <Route path="/aboutus" element={<AboutUs />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/survey" element={<Survey />} />
        </Routes>
    </Router>
    <ToastContainer />
    </>
  );
}

export default App;
